import React from 'react';
import { Link } from 'react-router-dom';

const Dropdown = () => (
  <div className='transform translate-y-0 text-xl grid grid-rows-7 text-center items-center bg-gray-100 font-semibold'>
    <Link to='/' className='dropDownLink'>
      בית
    </Link>
    <Link to='/about' className='dropDownLink'>
      אודותינו
    </Link>
    <Link to='/energy-efficiency' className='dropDownLink'>
      התייעלות אנרגטית
    </Link>
    <Link to='/energy-storage' className='dropDownLink'>
      אגירת אנרגיה
    </Link>
    <Link to='/funding' className='dropDownLink'>
       ומידע
    </Link>
    <Link to='/environment' className='dropDownLink'>
      איכות הסביבה
    </Link>
    <Link to='/contact' className='finalDropDownLink'>
      צרו קשר
    </Link>
  </div>
);

export default Dropdown;
